// Calls reset container script
Jelly.Interface.Call_Refresh_Container_Listeners = function() {
	$.each(Jelly.Interface.Refresh_Container_Listeners, function(Index, Value) {
		Value.call();
	});
};

Jelly.Interface.Call_Refresh_Listeners = function() {
	$.each(Jelly.Interface.Refresh_Listeners, function(Index, Value) {
		Value.call();
	});
};